import React from "react";
import { CONTACT_INFO } from "../data";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Phone Button */}
      <a
        href={`tel:${CONTACT_INFO.phoneRaw}`}
        className="group flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center bg-brand-brown text-white shadow-xl transition-all duration-300 ease-in-out hover:bg-brand-brown-dark hover:scale-110"
        aria-label={`Ring til os på ${CONTACT_INFO.phone}`}
      >
        <i className="fa-solid fa-phone text-lg transition-transform duration-300 group-hover:rotate-12" />
      </a>

      {/* Email Button */}
      <a
        href={`mailto:${CONTACT_INFO.email}`}
        className="group flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center bg-brand-graphite text-white shadow-xl transition-all duration-300 ease-in-out hover:bg-brand-brown hover:scale-110"
        aria-label={`Send en e-mail til ${CONTACT_INFO.email}`}
      >
        <i className="fa-regular fa-envelope text-lg transition-transform duration-300 group-hover:scale-110" />
      </a>
    </div>
  );
}
